<template>
  <div v-if="editor != 0">
    <ckeditor :editor="editor" :value="editorData" v-model="editorData" :config="editorConfig" :disabled="disabled"/>
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

export default {
  props: ['initialContent', 'placeholder', 'disabled', 'language'],
  data () {
    return {
      editor: 0,
      editorData: '',
      editorConfig: {
        toolbar: ['Bold', 'Italic', '|', 'NumberedList', 'BulletedList'],
        language: ''
      }
    }
  },
  mounted () {
    this.initializeEditor()
  },
  methods: {
    initializeEditor () {
      this.editorData = this.initialContent.value
      this.editor = ClassicEditor
      this.editorConfig.language = this.language
    }
  },
  watch: {
    initialContent () {
      this.initializeEditor()
    },
    editorData () {
      this.initialContent.value = this.editorData
      this.$emit('contentInterface', this.initialContent)
    }
  }
}
</script>
